const atualizarMapasCotacao = (state, mapasCotacao) => {
    state.mapasCotacao = mapasCotacao;
}

const atualizarMapaCotacao = (state, mapaCotacao) => {
    state.mapaCotacao = mapaCotacao;
}


const atualizarProdutosPreSelecionadosNovoMapa = (state, produtos) => {
    state.produtosPreSelecionadosNovoMapa = produtos ? JSON.parse(JSON.stringify(produtos)) : [];
}
const addMapaCotacao = (state, mapaCotacao) => {
    state.mapasCotacao.push(JSON.parse(JSON.stringify(mapaCotacao)));
}

const updateMapaCotacao = (state, mapaCotacao) => {
    const item = state.mapasCotacao.find(item => item.id === mapaCotacao.id);

    Object.assign(item, mapaCotacao);
}

export default {
    atualizarMapasCotacao,
    atualizarMapaCotacao,
    atualizarProdutosPreSelecionadosNovoMapa,
    addMapaCotacao,
    updateMapaCotacao,
}
